module.exports = __webpack_public_path__ + "img/mirage-g4-red-compressor.ff9e21e4.png";